<template>
    <v-tabs-items v-model="tab" touchless style="height:100%">
        <slot v-bind="{ tabs, tab, prev, next }" />
    </v-tabs-items>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import { TABS } from "./lib";

export default {
    props: {
        value: { type: String, default: TABS.VIEW.value },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        contract: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        tab: TABS.VIEW.value,
    }),
    computed: {
        tabs() {
            let tabs = Object.keys(TABS);

            let hasFileField = this.contract.fields_employee.some(({ type }) => type == EMPLOYMENT_FIELD_TYPES.FILE.value);

            if (hasFileField) return tabs;
            else return tabs.filter((tab) => tab != TABS.FILE.value);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.tab = this.value;
        },
        emit() {
            this.$emit("input", this.tab);
        },
        prev() {
            let index = this.tabs.findIndex((tab) => tab == this.tab);
            if (0 < index) this.tab = this.tabs[index - 1];
            this.emit();
        },
        next(tab) {
            let index = this.tabs.findIndex((tab) => tab == this.tab);
            if (index < this.tabs.length - 1) this.tab = this.tabs[index + 1];
            this.emit();
        },
    },
};
</script>

<style></style>
